var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 61,
    fill: "#474747"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Third Draft",
    clipPath: "url(#clip0_2624_26527)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2910,
    transform: "translate(-1034 -799)",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410091755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171277183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171277155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 695",
    filter: "url(#filter0_d_2624_26527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -591,
    y: -40.1411,
    width: 696,
    height: 157,
    rx: 9.30556,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -590.535,
    y: -39.6758,
    width: 695.069,
    height: 156.069,
    rx: 8.84028,
    stroke: "#E7E8F1",
    strokeWidth: 0.930556
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171277164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4240"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 112",
    x1: 28.7183,
    y1: 59.0098,
    x2: 28.7183,
    y2: 82.5862,
    stroke: "#A5AAAF",
    strokeWidth: 1.42887
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1171277185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4243"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 196",
    cx: 29.5,
    cy: 30.4347,
    rx: 29.5,
    ry: 29.5759,
    fill: "#ECFFEE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 197",
    cx: 29.502,
    cy: 30.4351,
    rx: 24.5,
    ry: 24.563,
    fill: "#D7FADC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 200",
    cx: 29.5,
    cy: 30.4358,
    rx: 18.5,
    ry: 18.5476,
    fill: "#BCF1C3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 198",
    cx: 29.5,
    cy: 30.4332,
    rx: 13.5,
    ry: 13.5347,
    fill: "#79BC83"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 199",
    cx: 8.28368,
    cy: 8.30212,
    rx: 8.28368,
    ry: 8.30212,
    transform: "matrix(0.965759 -0.25944 0.258199 0.966092 19.3555 24.5645)",
    fill: "#79BC83"
  })), /*#__PURE__*/React.createElement("path", {
    id: "You",
    d: "M21.5283 33.8589V30.6925L21.8598 31.607L18.3848 25.8572H19.9737L22.7628 30.4867H21.8712L24.6832 25.8572H26.1464L22.6714 31.607L23.0143 30.6925V33.8589H21.5283ZM29.0449 33.9389C28.42 33.9389 27.8637 33.8055 27.3759 33.5388C26.8882 33.2645 26.5034 32.8911 26.2214 32.4186C25.9394 31.9461 25.7985 31.4088 25.7985 30.8068C25.7985 30.1972 25.9394 29.6599 26.2214 29.195C26.5034 28.7226 26.8882 28.353 27.3759 28.0862C27.8637 27.8195 28.42 27.6862 29.0449 27.6862C29.6774 27.6862 30.2375 27.8195 30.7252 28.0862C31.2206 28.353 31.6054 28.7188 31.8797 29.1836C32.1617 29.6485 32.3027 30.1895 32.3027 30.8068C32.3027 31.4088 32.1617 31.9461 31.8797 32.4186C31.6054 32.8911 31.2206 33.2645 30.7252 33.5388C30.2375 33.8055 29.6774 33.9389 29.0449 33.9389ZM29.0449 32.7158C29.3954 32.7158 29.7079 32.6396 29.9822 32.4872C30.2565 32.3348 30.4699 32.1138 30.6223 31.8242C30.7824 31.5346 30.8624 31.1955 30.8624 30.8068C30.8624 30.4105 30.7824 30.0714 30.6223 29.7895C30.4699 29.4999 30.2565 29.2789 29.9822 29.1265C29.7079 28.974 29.3992 28.8978 29.0563 28.8978C28.7057 28.8978 28.3933 28.974 28.119 29.1265C27.8522 29.2789 27.6388 29.4999 27.4788 29.7895C27.3188 30.0714 27.2388 30.4105 27.2388 30.8068C27.2388 31.1955 27.3188 31.5346 27.4788 31.8242C27.6388 32.1138 27.8522 32.3348 28.119 32.4872C28.3933 32.6396 28.7019 32.7158 29.0449 32.7158ZM36.2524 33.9389C35.7342 33.9389 35.277 33.8436 34.8807 33.6531C34.4845 33.455 34.1758 33.1578 33.9548 32.7615C33.7338 32.3576 33.6233 31.8508 33.6233 31.2412V27.7547H35.0522V31.0469C35.0522 31.5956 35.1741 32.0071 35.418 32.2814C35.6695 32.5481 36.0238 32.6815 36.4811 32.6815C36.8164 32.6815 37.106 32.6129 37.3498 32.4757C37.6013 32.3386 37.7956 32.1328 37.9328 31.8585C38.0776 31.5841 38.15 31.245 38.15 30.8411V27.7547H39.5789V33.8589H38.2186V32.2128L38.4586 32.7158C38.2529 33.1121 37.9519 33.4169 37.5556 33.6303C37.1593 33.836 36.7249 33.9389 36.2524 33.9389Z",
    fill: "#FAFCFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2624_26527",
    x: -618.917,
    y: -64.3356,
    width: 751.833,
    height: 212.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.72222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.9583
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.051 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2624_26527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2624_26527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_26527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2910,
    fill: "white",
    transform: "translate(-1034 -799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou);
export default __webpack_public_path__ + "static/media/you.d337cc9cd86b6f55f1034b84bda0317d.svg";
export { ForwardRef as ReactComponent };